import React from 'react'
import ReactQuill from 'react-quill';
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import { checkIsValid } from './commonFunction';

type AppProps={
    modal:boolean;
    setModal:React.Dispatch<React.SetStateAction<boolean>>;
    setFileData:React.Dispatch<React.SetStateAction<string>>;
    fileData:string;
}

const toolbarOptions = [
    ["bold", "italic", "underline", "strike"], // toggled buttons
    ["blockquote", "code-block"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ script: "sub" }, { script: "super" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ direction: "rtl" }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }, { background: [] }],
    [{ font: [] }],
    [{ align: [] }],
    ["clean"]
  ];



const GuideLinesModal = ({modal,setModal,fileData,setFileData}:AppProps) => {

    const toggle=()=>{
      if(!checkIsValid(fileData)){
        setFileData("")
      }
        setModal((prev:boolean)=>!prev)
    }

  return (
    <div>
      <Modal
        centered
        isOpen={modal}
        toggle={toggle}
        size="m"
        backdrop="static"
      >
        <ModalHeader
          className="pt-3 pl-4"
          id="cross-cut"
          toggle={toggle}
          style={{ paddingBottom: "13px" }}
        >
          Guidelines
        </ModalHeader>
        <ModalBody
          className="pl-4 pr-4"
          style={{ paddingLeft: "40px", minHeight: "70vh" }}
        >
            <ReactQuill
          id="editor"
          value={fileData}
          onChange={setFileData}
          modules={{
            toolbar: toolbarOptions,
            imageResize: {
              modules: ["Resize", "DisplaySize"],
            },
          }}
          style={{ height: "50vh", fontSize: "16px", fontFamily: "sans-serif" }}
        />
         
        </ModalBody>
      </Modal>
    </div>
  )
}

export default GuideLinesModal
